import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { ArrowUpRight } from "lucide-react";

export default function RealisationsSection() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/realizations").then(r => setItems(r.data.slice(0, 6))); }, []);

  return (
    <section className="py-20 md:py-28 bg-[color:var(--brand-navy)] text-white" data-testid="realisations-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <div className="text-xs md:text-sm uppercase tracking-[0.2em] text-[color:var(--brand-sky)] font-semibold mb-3">Réalisations</div>
            <h2 className="font-display text-3xl md:text-5xl font-bold leading-tight">Des chantiers,<br/>des preuves.</h2>
          </div>
          <Link to="/realisations" className="inline-flex items-center gap-2 text-sm font-semibold text-white/90 hover:gap-3 transition-all group">
            Voir toutes <ArrowUpRight className="w-4 h-4 group-hover:rotate-45 transition-transform"/>
          </Link>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((r, i) => (
            <Link key={r.id} to={`/realisations/${r.slug}`}
              className="group relative overflow-hidden rounded-2xl aspect-[4/5] bg-white/5"
              data-testid={`realisation-card-${r.slug}`}
            >
              {r.images?.[0] && (
                <img src={r.images[0]} alt={r.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"/>
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"/>
              <div className="absolute top-4 left-4 flex gap-2">
                {r.category && (
                  <span className="px-2.5 py-1 rounded-full bg-white/95 text-[color:var(--brand-navy)] text-[11px] font-bold uppercase tracking-wider">
                    {r.category}
                  </span>
                )}
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="text-xs text-white/70 mb-1">{r.zone}</div>
                <h3 className="font-display text-lg md:text-xl font-bold text-white line-clamp-2">{r.title}</h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
